"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPicker = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

/* Return the relative coordinates for a click on a color box (gradient or spectrum) */
var getClickPositionFor = function getClickPositionFor(name, event) {
  var target = event.target; // a click event could happen over the pointer, we scan the tree looking for the chosen element

  while (target && !target.getAttribute("data-is-".concat(name))) {
    target = target.parentElement;
  }

  var coords = target.getBoundingClientRect();
  var x = Math.min(1, Math.max(0, (event.clientX - coords.x) / coords.width));
  var y = Math.min(1, Math.max(0, 1 - (event.clientY - coords.y) / coords.height));
  return {
    x: x,
    y: y
  };
};
/* Infers the relative pointer position in the gradient box for a given color value */


var color2Position = function color2Position(value) {
  var color = (0, _color["default"])(value).hsl();
  var saturation = color.saturationl() / 100;
  var lightness = color.lightness() / 100;
  var x = saturation;
  var y = 1;
  var lineLightness = 1 - x / 2;
  if (lightness <= lineLightness) y = lightness / lineLightness;else x -= lightness - lineLightness;
  return {
    x: x,
    y: y
  };
};
/* Infers the color for a given relative position of the gradient box */


var gradientPosition2Color = function gradientPosition2Color(event, base) {
  var _getClickPositionFor = getClickPositionFor('gradient', event),
      x = _getClickPositionFor.x,
      y = _getClickPositionFor.y;

  var saturation = 100 * x;
  var lineLightness = 100 - saturation / 2;
  var lightness = lineLightness * y;
  var color = (0, _color["default"])("hsl(".concat(base.hue(), ",").concat(saturation, "%,").concat(lightness, "%)"));
  return color.hex();
};
/* Infers the color for a given relative position on the spectrum box */


var spectrumPosition2Color = function spectrumPosition2Color(event, color) {
  var _getClickPositionFor2 = getClickPositionFor('spectrum', event),
      x = _getClickPositionFor2.x;

  return color.hue(350 * x).hex();
};
/* Update the pointer on the gradient box when dragging */


var mouseMoveGradient = function mouseMoveGradient(event, base, updateColor, setLastPosition) {
  if (event.buttons != 1) return;
  updateColor(gradientPosition2Color(event, base), false);
  setLastPosition(getClickPositionFor('gradient', event));
};
/* Update the pointer on the spectrum box when dragging */


var mouseMoveSpectrum = function mouseMoveSpectrum(event, color, updateColor, updateBase) {
  if (event.buttons != 1) return;

  var _getClickPositionFor3 = getClickPositionFor('spectrum', event),
      x = _getClickPositionFor3.x;

  updateBase((0, _color["default"])("hsl(".concat(x * 350, ", 100%, 50%)")));
  updateColor(spectrumPosition2Color(event, color), false);
};

var ColorPicker = function ColorPicker(_ref) {
  var classes = _ref.classes,
      colorCode = _ref.colorCode,
      updateColor = _ref.updateColor,
      base = _ref.base,
      updateBase = _ref.updateBase,
      findPosition = _ref.findPosition,
      setFindPosition = _ref.setFindPosition;
  var color = (0, _color["default"])(colorCode);
  var hueOffset = "".concat(100 * base.hue() / 360, "%");
  var background = "linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1)), linear-gradient(to right, rgb(255,255,255), ".concat(base, ")");

  var _useState = (0, _react.useState)({
    x: 0,
    y: 0
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      lastPosition = _useState2[0],
      setLastPosition = _useState2[1];

  (0, _react.useEffect)(function () {
    if (findPosition) {
      setFindPosition(false);
      setLastPosition(color2Position(colorCode));
    }
  }, [findPosition, colorCode, setFindPosition]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ColorPicker,
    "data-test-id": "color-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Arrow
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-is-gradient": true,
    className: classes.Gradient,
    style: {
      background: background
    },
    onMouseMove: function onMouseMove(event) {
      return mouseMoveGradient(event, base, updateColor, setLastPosition);
    },
    onClick: function onClick(event) {
      return updateColor(gradientPosition2Color(event, base), false);
    },
    onMouseUp: function onMouseUp(event) {
      return setLastPosition(getClickPositionFor('gradient', event));
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Pointer,
    style: {
      top: "".concat(100 - 100 * lastPosition.y, "%"),
      left: "".concat(100 * lastPosition.x, "%"),
      background: colorCode
    },
    "data-test-id": "color-gradient-pointer"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-is-spectrum": true,
    className: classes.Spectrum,
    onMouseMove: function onMouseMove(event) {
      return mouseMoveSpectrum(event, color, updateColor, updateBase);
    },
    onClick: function onClick(event) {
      updateColor(spectrumPosition2Color(event, color));
    },
    "data-test-id": "color-spectrum"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Pointer,
    style: {
      top: '50%',
      left: hueOffset,
      background: base.hex()
    }
  })));
};

exports.ColorPicker = exports["default"] = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map